import { animate, keyframes, style, transition, trigger } from '@angular/animations';
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  OnDestroy,
  Renderer2,
  ViewChild,
  OnChanges,
  type SimpleChanges,
  Inject,
  ChangeDetectorRef,
  NgZone,
  DOCUMENT
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { faChevronDown, faBell, faLanguage, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import {
  BookerType,
  CarbonAllowance,
  EnterpriseBasketService,
  EnterpriseSearchService,
  HelperRoutines,
  LogonService,
  Message,
  ModalOpenerService,
  ServiceType,
  UserService,
  WithSubscriptionComponent,
  BasketItem,
  User,
  Language
} from '@sabstravtech/obtservices/angular';
import {
  FullUserDetails,
  EnableFreshChat,
  EnableFreshChatValue,
  ServiceProvider
} from '@sabstravtech/obtservices/base';
import { TranslateService } from '@ngx-translate/core';

import { LightningUserFavorurite } from '../core/classes/user-favourite.enum';
import { resultIcons } from '../core/enum/result-icons.enum';
import { LightningModalTypes } from '../core/classes/modal-types.enum';
import { DDAService } from '../core/services/dda.service';
import { ScriptLoaderService } from '../core/services/script-loader.service';
import { environment } from '../../environments/environment';
import { WCAGFocusHandler } from '../core/services/wcag-focus-handler.service';
import { LanguageService } from '../core/services/language.service';
import { ThemeService } from '../core/services/theme.service';

// import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-results-header',
  templateUrl: './results-header.component.html',
  styleUrls: ['./results-header.component.scss'],
  animations: [
    trigger('flyInOut', [
      transition('* => *', [
        animate(
          '350ms 0ms ease-in',
          keyframes([
            style({ opacity: 1, transform: 'translateY(0)' }),
            style({ opacity: 1, transform: 'translateY(-5px)' }),
            style({ opacity: 1, transform: 'translateY(-10px)' }),
            style({ opacity: 1, transform: 'translateY(-15px)' }),
            style({ opacity: 1, transform: 'translateY(-10px)' }),
            style({ opacity: 1, transform: 'translateY(-5px)' }),
            style({ opacity: 0, transform: 'translateY(0)' })
          ])
        )
      ])
    ])
  ],
  standalone: false
})
export class ResultsHeaderComponent
  extends WithSubscriptionComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() public blank = false;
  @Input() public homeIcon = true;
  @Input() public logoutIcon = true;
  @Input() public transparent = false;
  @Input() public userIcon = true;
  @Input() public page = '';
  @Input() public basketStatus = 0;
  @Input() public openBasket: BasketItem[] = [];
  @Input() public isSubHidden = false;

  @ViewChild('main') main: ElementRef;
  @ViewChild('basket') basket: ElementRef;

  public isBeamerOpen = false;
  private beamerObserver: MutationObserver;
  private beamerSelectorObserver: MutationObserver;
  private beamerBodyObserver: MutationObserver;
  private removeDocumentFocusInListener: (() => void) | null = null;
  private suppressBeamerCloseFocusRestoreUntil = 0;

  public overrideTravelPolicy = false;
  public resultsType: string;
  public display_user_data = false;
  public displayAnn = false;
  public user_info = null;
  private _lastUrl = '';
  public helpUrl: string = null;
  public supportMessage: string = null;
  public covidHubOpen = false;
  public BookerType = BookerType;
  public search_loading = false;
  public ShowUserOptionsToggle = false;
  public annCount = 0;

  public userCarbonAllowance: CarbonAllowance;
  public carbonPolicyHeader = '';
  public startOfPeriod = '';
  public endOfPeriod = '';
  public showCarbonPolicy = false;
  public homepage = '';
  public toggleAnn = false;
  public live = false;
  public menuOpen = false;
  public showLiveRail = true;
  public isUserAdmin: boolean;
  public isRoot = false;
  public isSupportAgent = false;
  public isTmcAdmin: boolean;
  public hideCovidTest = false;
  public announcementsImgSrc =
    'https://images.sabscorp.com/images/enterprise/lightUK/greyAlert.svg';
  public announcementsImgSrcWhite =
    'https://images.sabscorp.com/images/enterprise/lightUK/whiteAlert.svg';
  public announcementsImg = this.announcementsImgSrc;
  resultItemType = resultIcons;
  name_initials: string;
  faChevronDown = faChevronDown;
  faBell = faBell;
  basketItemTypes: ServiceType[] = [];
  isMainPage = false;
  toggleLanguagesState = false;
  toggleUsefulInfoState = false;
  faLanguage = faLanguage;
  faChevronUp = faChevronUp;
  selectedLanguage: Language;
  availableLanguages: Language[] = [];
  logoUrl: string = null;
  showUsefulInformationDropdown = false;
  displayUsefulInformation: boolean;
  showUsefulInfoToggle: boolean;
  canBecomeUser = false;
  showDTD = true;
  public contactUrl =
    this.helpers.isOnDev() || this.helpers.isOnStaging()
      ? 'https://test.ctmlightning.co.uk/crown/contacts/'
      : 'https://ctmlightning.co.uk/crown/contacts/';
  public feedbackUrl = 'https://travelctmnorth-clients.freshdesk.com/support/home';
  public userGuidesUrl = 'https://travelctmnorth-clients.freshdesk.com/support/home';
  public priceMatchUrl = 'https://www.ctmlightning.co.uk/crown/CTM_Price_Match_for_CCS.pdf';

  constructor(
    // public readonly annService: AnnouncementService,
    public readonly basketService: EnterpriseBasketService,
    private readonly router: Router,
    private readonly modalService: ModalOpenerService,
    private readonly userService: UserService,
    public readonly searchService: EnterpriseSearchService,
    private readonly logonService: LogonService,
    private readonly ddService: DDAService,
    private readonly scriptLoaderService: ScriptLoaderService,
    public translator: TranslateService, // private readonly bookOnBehalfService: BookOnBehalfService // private readonly changeUserService: ChangeUserService
    private helpers: HelperRoutines,
    private wcagFocusHandlerService: WCAGFocusHandler,
    private languageService: LanguageService,
    protected themeService: ThemeService,
    @Inject(DOCUMENT) public document: Document,
    private readonly cdr: ChangeDetectorRef,
    private readonly ngZone: NgZone,
    private readonly renderer2: Renderer2
  ) {
    super();
  }

  ngOnInit(): void {
    this.removeDocumentFocusInListener = this.renderer2.listen(
      'document',
      'focusin',
      (event: FocusEvent) => this.onDocumentFocusIn(event)
    );

    if (this.page === 'become user' && !this.userService.fullUserDetails.userData.value) {
      this.router.navigate(['search']);
    }
    this.getUserDropdownInfo();
    this.isRoot = this.userService.userIsRoot();
    this.isSupportAgent = this.userService.userIsSupportAgent();
    this.isTmcAdmin = this.userService.userIsTmcAdmin();
    this.canBecomeUser = this.userService.fullUserDetails.allDetails.value?.becomeUser;
    this.subscribe(this.userService.changeUser, (fullUser: FullUserDetails) => {
      if (fullUser && fullUser.userData.value) {
        this.isRoot = this.userService.userIsRoot();
        this.live = fullUser.userData.value.live;
        this.selectedLanguage = fullUser.allDetails.value?.selectedLanguage;
        this.availableLanguages = fullUser.allDetails.value?.availableLanguages;
      }
      this.homepage = this.userService.getUserFavoriteValue(LightningUserFavorurite.homepage);
      this.showDTD = (
        this.userService.getUserFavoriteObject(LightningUserFavorurite.EnableDoorToDoor) as {
          value: boolean;
        }
      )?.value;
      this.showUsefulInformationDropdown = (
        this.userService.getUserFavoriteObject(LightningUserFavorurite.UsefulInformation) as {
          enable: boolean;
        }
      )?.enable;
      this.hideCovidTest = (
        this.userService.getUserFavoriteObject(LightningUserFavorurite.HideCovidTest) as {
          value: boolean;
        }
      )?.value;
      // show/hide Live Rail tab
      this.showLiveRail =
        this.userService.userHasServiceProvider(ServiceType.Rail, ServiceProvider.Evolvi) ||
        this.userService.userHasServiceProvider(ServiceType.Rail, ServiceProvider.Trainline);
      if (!this.userService.freshChatAdded) {
        const enableFreshChat: EnableFreshChatValue =
          this.userService.getUserFavoriteObject<EnableFreshChat>(
            LightningUserFavorurite.EnableFreshChat
          )?.value;

        if (enableFreshChat?.enable) {
          this.initFreshChat(enableFreshChat);
        }
      }
    });
    this.subscribe(this.userService.fullUserDetails.allDetails, (data: User) => {
      if (data) {
        this.selectedLanguage = data?.selectedLanguage;
        this.availableLanguages = data?.availableLanguages;
        this.canBecomeUser = data?.becomeUser;
      }
    });
    this.initialize();
    this.subscribe(this.router.events, this.initialize.bind(this));

    this.isUserAdmin = this.userService.userIsAdmin() || this.userService.userIsCompanyAdmin();
    if (this.themeService.isLightningEnv) {
      this.setupBeamer();
    }
    this.logoUrl = this.themeService.getLogo();
  }

  updateLanguage(id: string) {
    const payload = {
      selectedLanguage: id
    };

    this.subscribe(this.userService.editUser(payload), (user: User) => {
      let languageUpdate = false;
      if (this.selectedLanguage.id !== user.selectedLanguage.id) {
        languageUpdate = true;
      }
      if (user) {
        if (languageUpdate) {
          const selectedLanguage = user.selectedLanguage;
          const availableLanguages = user.availableLanguages.map((lang: Language) => lang.isoCode);
          this.languageService.changeLanguageFromUserDetails(
            selectedLanguage.name,
            selectedLanguage.isoCode,
            availableLanguages
          );
        }
        this.modalService.open(
          LightningModalTypes.ModalSuccessComponent,
          { centered: true },
          { success: 'Language has been successfully changed' }
        );
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.openBasket) {
      this.basketItemTypes = this.getBasketItemTypes(this.openBasket);
    }
  }

  initFreshChat(enableFreshchat: EnableFreshChatValue) {
    this.userService.freshChatAdded = true;
    console.warn('+++ FRESHCHAT INIT +++');
    this.scriptLoaderService.addScript('https://wchat.eu.freshchat.com/js/widget.js').then(() => {
      const fcWidget = (<any>window).fcWidget;
      if (fcWidget) {
        const self = this;
        if (fcWidget) {
          fcWidget.init({
            token: enableFreshchat.token,
            host: 'https://wchat.eu.freshchat.com',
            firstName: self.userService.getUserForename(),
            lastName: self.userService.getUserSurname(),
            email: self.userService.getUserEmail(),
            phone: self.userService.getFullPhoneNumber()
          });
          fcWidget.user.get((resp: any) => {
            const status = resp && resp.status;
            if (status !== 200) {
              fcWidget.user.setProperties({
                firstName: self.userService.getUserForename(),
                lastName: self.userService.getUserSurname(),
                email: self.userService.getUserEmail(),
                phone: self.userService.getFullPhoneNumber()
              });
            }
          });
        }
      }
    });
  }

  async initBeamer(): Promise<void> {
    console.warn('initiating beamer');
    this.userService.beamerAdded = true;
    return this.scriptLoaderService
      .addScript('https://app.getbeamer.com/js/beamer-embed.js')
      .then((event) => {
        // Ensuring we're able to access the beamer push notification prompt as soon as it opens, bit hacky but all we can do with it being third party
        // @ts-ignore
        const native = Beamer.showNotificationPrompt;
        // @ts-ignore
        Beamer.showNotificationPrompt = function () {
          native.apply(window, arguments);
          // I've checked the beamer code and it opens the modal after 1500ms
          setTimeout(() => {
            const noButton = document.getElementById('pushActionRefuse');
            const yesButton = document.getElementById('pushConfirmation');
            if (noButton && yesButton) {
              // This ensures that visually hidden descriptive text is available to screen readers
              noButton.innerHTML =
                noButton.innerHTML +
                '<span class="sr-only">&nbsp;- Decline beamer push notifications</span>';
              yesButton.innerHTML =
                yesButton.innerHTML +
                '<span class="sr-only">&nbsp;- Accept beamer push notifications</span>';
              // This ensures the focus is trapped within the modal as it should be for modals
              noButton.onkeydown = (event) => {
                if (event.key === 'Tab' && event.shiftKey) {
                  event.preventDefault();
                }
              };
              yesButton.onkeydown = (event) => {
                if (event.key === 'Tab' && !event.shiftKey) {
                  event.preventDefault();
                }
              };
              noButton.focus();
            }
          }, 1500);
        };
      });
  }

  udpateAnnCount(annCount: { annCount: number; announcements: Message[] }) {
    this.annCount = annCount.annCount;
    const keys = Object.keys(annCount.announcements);

    for (const key of keys) {
      const page = annCount.announcements[key];
      // console.log(page);
      const found = page.filter((ann) => ann.collapse);
      if (found?.length) {
        return;
      } // break out, so we don't auto open
    }

    if (this.annCount) {
      this.toggleAnn = true;
    }
  }

  openAnn(): void {
    this.toggleAnn = true;
  }

  closeAnn(): void {
    this.toggleAnn = false;
  }

  /**
   * Focus container on page
   * @see window browser window element
   * @param containerName
   */
  focusContainer(containerName: string, event?: Event): boolean {
    try {
      event?.preventDefault();
      event?.stopPropagation();

      const container =
        this.ddService[containerName]?.nativeElement || this.document.getElementById(containerName);

      if (container) {
        container.setAttribute('tabindex', '-1');
        container.focus();
      }
    } catch (e) {
      console.error(e);
    }
    return false;
  }

  initialize(): void {
    if (this.router.url !== this._lastUrl) {
      const split = this.router.url.split('/'); // used to determine the background
      const resultsType = split[split.length - 1];
      this.resultsType = resultsType.replace(/s$/, '');
      this._lastUrl = this.router.url;
    }
  }

  openAdminModal(): void {
    const url = this.helpers.isOnDev()
      ? environment.ADMIN_USER_PANEL_DEVELOP
      : this.helpers.isOnStaging()
        ? environment.ADMIN_USER_PANEL_STAGING
        : this.helpers.isOnMistest()
          ? environment.ADMIN_USER_PANEL_MISTEST
          : environment.ADMIN_USER_PANEL;
    window.open(url, '_blank');
  }

  openSupport(): void {
    this.modalService.open(
      LightningModalTypes.ModalSupportEmailComponent,
      { centered: true },
      { message: this.supportMessage }
    );
  }

  showSupportEmail(): boolean {
    /* TODO
    const user = this.userService.getUserDetails();
    return Boolean((user && user.BookingAllowedFor === 'AgentBook') || (this.userService.userIsClient() && this.supportMessage));
    */
    return false;
  }

  logout(): void {
    this.modalService
      .open(
        LightningModalTypes.ModalConfirmComponent,
        {
          centered: true
        },
        {
          message_header: this.translator.instant('Confirmation needed'),
          message: this.translator.instant('Please select as appropriate'),
          btnOkText: this.translator.instant('Yes sign me out'),
          btnCancelText: this.translator.instant('Sorry let me stay')
        }
      )
      .then((result) => {
        if (result) {
          // if (document.cookie.includes('is.authenticated=true')) {
          //     this.auth.logout({
          //         logoutParams: {
          //             returnTo: environment.redirectUrlScion // this is hardcoded to dev, need to check env properly like admin panel url
          //         }
          //     });
          // }
          this.logonService.logout();
          this.searchService.reset();
          (window as any).pendo?.stop?.(); // Stops the current Pendo session
        }
      });
  }

  resetAndBackToSearch(): void {
    this.userService.setBobo(null);
    this.searchService.reset();
    this.router.navigate(['search']);
  }

  /**
   * Reset all chosen products and re-apply default start tab
   * Called when clicking "New Booking"
   */
  resetToNewBooking(): void {
    if (this.userService.bobo) {
      this.userService.setBobo(null);
    }
    this.searchService.resetSearchChosenObjects();
    const currentServices = this.userService.fullUserDetails.userServices.value;

    if (currentServices) {
      const servicesKeys = Object.keys(currentServices);
      const startTab = this.userService.getUserFavoriteValue(LightningUserFavorurite.startTab);
      const isStartTabIncluded =
        startTab && servicesKeys.length ? servicesKeys.includes(ServiceType[startTab]) : false;

      if (isStartTabIncluded && startTab) {
        // Set the start tab chosen flag immediately
        if (
          this.searchService.search_objects &&
          this.searchService.search_objects[ServiceType[startTab]]
        ) {
          this.searchService.search_objects[ServiceType[startTab]].chosen = true;
          this.searchService.search_objects[ServiceType[startTab]].originalChosen = true;
          this.searchService.search_objects[ServiceType[startTab]].autosearch = false;
          this.searchService.determineHighestSearchPriority();
        }
      }
    }
  }

  /**
  @desc - function to display the user data dropdown
  **/
  displayUserData(): void {
    this.display_user_data = !this.display_user_data;
    this.ShowUserOptionsToggle = !this.ShowUserOptionsToggle;
  }

  closeUserDropdownIfFocusLeaves(): void {
    setTimeout(() => {
      if (!this.display_user_data) {
        return;
      }

      const userDropdownContainer = this.document.getElementById('user-dropdown-container');
      const activeElement = this.document.activeElement;

      if (userDropdownContainer?.contains(activeElement)) {
        return;
      }

      this.display_user_data = false;
      this.ShowUserOptionsToggle = false;
    }, 0);
  }

  displayUsefulLinks() {
    this.displayUsefulInformation = !this.displayUsefulInformation;
    this.showUsefulInfoToggle = !this.showUsefulInfoToggle;
  }

  onDocumentFocusIn(event: FocusEvent): void {
    const overlay = this.document.getElementById('beamerOverlay');
    const target = event.target as Node | null;

    if (!overlay || !target) {
      return;
    }

    const isOverlayOpen =
      overlay.classList.contains('beamer_show') ||
      (overlay.style.display !== 'none' && overlay.style.display !== '');

    if (!isOverlayOpen) {
      return;
    }

    if (overlay.contains(target)) {
      return;
    }

    this.closeBeamerOverlay(false);
  }

  getUserDropdownInfo() {
    this.user_info = this.userService.getUserDropdownInfo();
    const fullName = this.user_info?.name.split(' ');
    const initials = fullName.shift().charAt(0) + fullName.pop().charAt(0);
    this.name_initials = initials.toUpperCase();
  }

  /**
  @desc - open the become user modal
  **/
  openBecomeUserModal(): void {
    this.display_user_data = false; // close the dropdown
    this.router.navigate(['/changeuser']);
  }

  openBehalfUserModal(): void {
    this.display_user_data = false; // close the dropdown
    this.router.navigate(['/changeuser']);
  }

  async endUserSession(): Promise<void> {
    await this.logonService.endBecomeUserSession();
    this.searchService.removeAllTravellers();
    this.basketService.resetBaskets();
    if (this.router.url === '/search') {
      // this is needed so we see the updated data
      window.location.reload();
    } else {
      this.router.navigate(['/search']);
    }
  }
  /**
  @desc - determine if we have a agency user that has become another user
  **/
  haveAgencyUser(): boolean {
    /* TODO
    if (this.userService.getAgencyUser()) {
      return true;
    }*/

    return false;
  }

  backToAgencyUser(): void {
    // TODO
  }

  /**
    @desc - login as the passed in agency user - call list users, then go to the logon service and user those functions
  **/
  loginAsAgencyUser(user: any): void {
    // TODO
  }

  getIconClass(searchObject: ServiceType) {
    switch (searchObject) {
      case ServiceType.Hotel:
        return 'ico-bed';
      case ServiceType.Flight:
        return 'ico-flight';
      case ServiceType.Rail:
      case ServiceType.InternationalRail:
        return 'ico-rail';
      case ServiceType.Car:
        return 'ico-car';
      case ServiceType.Lounge:
        return 'ico-m-lounge';
      case ServiceType.Parking:
        return 'ico-m-parking';
      case ServiceType.Cab:
        return 'ico-taxi';
      case ServiceType.Eurostar:
        return 'custom_icon-eurostar';
      case ServiceType.FastTrack:
        return 'ico-material ico-fast-track';
      case ServiceType.LongStays:
        return 'custom_icon-apartment';
      case ServiceType.Ambulance:
        return 'ico-ambulance ico-material';
      default:
        return 'ico-dot';
    }
  }

  cancelBookBehalf(): void {
    this.display_user_data = false; // close the dropdown
    // this.userService.onBehalfUser = undefined;
    // this.bookOnBehalfService.bookAsChange.emit(false);
  }

  isOnHomePage(): boolean {
    return this.router.url === '/landingPageBrand';
  }

  userIsClient(): boolean {
    return true; // TODO this.userService.userIsClient();
  }

  isOnHomePageOrBasket(): boolean {
    return this.router.url === '/main' || this.router.url.includes('/itinerary');
  }

  isOnLiveRail(): boolean {
    return this.router.url === '/live-rail';
  }

  isOnSearch(): boolean {
    return this.router.url === '/search';
  }

  showLanguages(): boolean {
    // if (this.userService.getAgencyUser()) {
    //   return Boolean(this.userService.getUserFavoriteValue(UserFavorurite.languages)) && Boolean(typeof this.userService.getUserAgentLanguage() === 'number');
    // } else {
    return Boolean(this.userService.getUserFavoriteValue(LightningUserFavorurite.languages));
    // }
  }

  hasRecentSearches(): boolean {
    return document.getElementById('recent_searches_container') ? true : false;
  }

  isOnResults(): boolean {
    return this.router.url.includes('results');
  }

  toggleCovidHub(): void {
    this.covidHubOpen = !this.covidHubOpen;
  }

  closeCovidHubIfFocusLeft(event, index): void {
    if (index === 0 && event.shiftKey && event.keyCode === 9) {
      this.covidHubOpen = false;
    }
    if (index === 1 && !event.shiftKey && event.keyCode === 9) {
      this.covidHubOpen = false;
    }
  }

  goToLiveRail(event = null) {
    if (event) {
      event.preventDefault();
    }
    // this.searchService.isLiveRail = true;
    this.router.navigate(['live-rail']);
  }

  checkToCloseMenu() {
    const context = this;
    setTimeout(function () {
      if (!document.getElementById('mobile_menu').contains(document.activeElement)) {
        context.menuOpen = false;
      }
    }, 0);
  }

  setupBeamer(): void {
    const attachBeamerCallbacks = () => {
      const config = (<any>window).beamer_config || {};
      config.onOpen = () => {
        this.ngZone.run(() => {
          this.isBeamerOpen = true;
          this.setBeamerIframeTitle();
          this.updateBeamerSelectorAriaLabel();
          this.cdr.markForCheck();
        });
      };
      config.onClose = () => {
        this.ngZone.run(() => {
          this.isBeamerOpen = false;
          if (Date.now() > this.suppressBeamerCloseFocusRestoreUntil) {
            this.focusBeamerTrigger();
          }
          this.updateBeamerSelectorAriaLabel();
          this.cdr.markForCheck();
        });
      };
      (<any>window).beamer_config = config;
    };

    if (!this.userService.beamerAdded) {
      this.initBeamer()
        .then(() => {
          const companyName = this.userService.fullUserDetails?.userData?.value?.company_name;
          const bookerType = this.userService.fullUserDetails?.userData?.value?.booker_type;
          (<any>window).beamer_config = {
            product_id: 'pbKlAiRw44591', // DO NOT CHANGE: This is your product code
            user_company: companyName,
            user_role: bookerType
          };
          attachBeamerCallbacks();
          this.initBeamerOverlayObserver();
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      attachBeamerCallbacks();
      this.initBeamerOverlayObserver();
    }
  }

  updateBeamerSelectorAriaLabel(): void {
    const selector = document.getElementById('beamerSelector');
    if (!selector) {
      return;
    }
    let unreadCount = 0;
    if (typeof (window as any).Beamer?.getUnreadCount === 'function') {
      try {
        const count = (window as any).Beamer.getUnreadCount();
        if (typeof count === 'number' && count > 0) {
          unreadCount = count;
        }
      } catch (e) {}
    }
    if (unreadCount === 0) {
      const icon = selector.querySelector('.beamer_icon') as HTMLElement;
      if (icon) {
        const styleDisplay = icon.style?.display;
        const isHidden = styleDisplay === 'none' || icon.getAttribute('aria-hidden') === 'true';
        if (!isHidden) {
          const countText = icon.textContent?.trim() || '';
          const parsed = parseInt(countText, 10);
          if (!isNaN(parsed) && parsed > 0) {
            unreadCount = parsed;
          }
        }
      }
    }
    const baseLabel = "What's new in Lightning";
    let label = baseLabel;
    if (unreadCount === 1) {
      label = `${baseLabel}, 1 unread notification`;
    } else if (unreadCount > 1) {
      label = `${baseLabel}, ${unreadCount} unread notifications`;
    }
    if (selector.getAttribute('aria-label') !== label) {
      selector.setAttribute('aria-label', label);
    }
    if (!selector.hasAttribute('aria-haspopup')) {
      selector.setAttribute('aria-haspopup', 'dialog');
    }
    if (!selector.hasAttribute('aria-controls')) {
      selector.setAttribute('aria-controls', 'beamerOverlay');
    }
    const expandedVal = this.isBeamerOpen ? 'true' : 'false';
    if (selector.getAttribute('aria-expanded') !== expandedVal) {
      selector.setAttribute('aria-expanded', expandedVal);
    }
  }

  initBeamerOverlayObserver(): void {
    const checkSelector = () => {
      const selector = document.getElementById('beamerSelector');
      if (selector) {
        this.updateBeamerSelectorAriaLabel();
        if (!this.beamerSelectorObserver) {
          this.beamerSelectorObserver = new MutationObserver(() => {
            this.updateBeamerSelectorAriaLabel();
          });
          this.beamerSelectorObserver.observe(selector, {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: true
          });
        }
        return true;
      }
      return false;
    };

    const checkOverlay = () => {
      const overlay = document.getElementById('beamerOverlay');
      if (overlay) {
        const isOpen =
          overlay.classList.contains('beamer_show') ||
          (overlay.style.display !== 'none' && overlay.style.display !== '');
        if (this.isBeamerOpen !== isOpen) {
          this.ngZone.run(() => {
            this.isBeamerOpen = isOpen;
            this.updateBeamerSelectorAriaLabel();
            this.cdr.markForCheck();
          });
        }
        if (!this.beamerObserver) {
          this.beamerObserver = new MutationObserver(() => {
            const openState =
              overlay.classList.contains('beamer_show') ||
              (overlay.style.display !== 'none' && overlay.style.display !== '');
            if (this.isBeamerOpen !== openState) {
              this.ngZone.run(() => {
                this.isBeamerOpen = openState;
                this.updateBeamerSelectorAriaLabel();
                this.cdr.markForCheck();
              });
            }
          });
          this.beamerObserver.observe(overlay, {
            attributes: true,
            attributeFilter: ['class', 'style']
          });
        }
        return true;
      }
      return false;
    };

    const overlayReady = checkOverlay();
    const selectorReady = checkSelector();

    if (!overlayReady || !selectorReady) {
      this.beamerBodyObserver = new MutationObserver(() => {
        const o = checkOverlay();
        const s = checkSelector();
        if (o && s) {
          this.beamerBodyObserver?.disconnect();
          this.beamerBodyObserver = null;
        }
      });
      this.beamerBodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  override ngOnDestroy(): void {
    if (this.removeDocumentFocusInListener) {
      this.removeDocumentFocusInListener();
      this.removeDocumentFocusInListener = null;
    }
    if (this.beamerObserver) {
      this.beamerObserver.disconnect();
    }
    if (this.beamerSelectorObserver) {
      this.beamerSelectorObserver.disconnect();
    }
    if (this.beamerBodyObserver) {
      this.beamerBodyObserver.disconnect();
    }
    super.ngOnDestroy();
  }

  setBeamerIframeTitle() {
    setTimeout(() => {
      // Needs a timeout to allow the iframe to be initialised
      const iframe = document.getElementById('beamerNews');
      if (iframe) {
        iframe.setAttribute('title', 'Beamer News Iframe');
        iframe.setAttribute('aria-label', "What's new on Lightning");
      }
    }, 0);
  }

  private closeBeamerOverlay(restoreFocus = true): void {
    const overlay = this.document.getElementById('beamerOverlay');
    if (overlay) {
      if (!restoreFocus) {
        this.suppressBeamerCloseFocusRestoreUntil = Date.now() + 750;
      }
      overlay.classList.remove('beamer_show');
      overlay.style.display = 'none';
      this.isBeamerOpen = false;
      this.cdr.markForCheck();
      if (restoreFocus) {
        this.focusBeamerTrigger();
      }
      return;
    }

    const trigger = this.document.querySelector<HTMLElement>('.beamerTrigger');
    if (trigger) {
      trigger.click();
      if (restoreFocus) {
        this.focusBeamerTrigger();
      }
    }
    this.isBeamerOpen = false;
    this.cdr.markForCheck();
  }

  private focusBeamerTrigger(): void {
    const trigger = this.document.querySelector<HTMLElement>('.beamerTrigger');
    trigger?.focus();
  }

  focusBasketButton(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    this.wcagFocusHandlerService.skipToBasketClicked.emit();
  }

  redirect(page: string): void {
    this.router.navigate([page]).then(() => {
      this.searchService.reset();
    });
  }

  getBasketItemTypes(basket: BasketItem[] = []): ServiceType[] {
    return basket.reduce((types, item) => {
      const itemType = item.service.type;
      if (!types.includes(itemType)) {
        types.push(itemType);
      }
      return types;
    }, []);
  }

  hasStandardLogo(): boolean {
    return (
      this.logoUrl === 'https://images.sabscorp.com/images/enterprise/lightUK/lightningLogo.svg'
    );
  }

  openContactsUrl(): void {
    window.open(this.contactUrl, '_blank');
  }

  openFeedbackUrl(): void {
    window.open(this.feedbackUrl, '_blank');
  }

  openUserGuides(): void {
    window.open(this.userGuidesUrl, '_blank');
  }

  openPriceMatch(): void {
    window.open(this.priceMatchUrl, '_blank');
  }

  removeIfInvoked(): void {
    this.userService.setBobo(null);
  }
}
